import { RouterChild } from '@/router';

export default [
  {
    name: 'admin-cars',
    path: 'cars',
    component: () => import('./views/Overview.vue')
  } as RouterChild
];
